import { useState, useEffect, Fragment } from 'react'
import useInView from '../../../hooks/useInView'
import Wrapper from '../../Wrapper/Wrapper'
import Count from '../../Counter/Counter'
import Text from 'components/common/BaseText/BaseText'
import { Divider } from '@mui/material'
import './Stats.scss'

const Stats = () => {
	const [countingFinished, setCountingFinished] = useState(false)
	const [windowSize, setWindowSize] = useState({ height: window.innerHeight, width: window.innerWidth })

	const isMobile = windowSize.width <= 768

	const { ref: projectsRef, inView: projectInView } = useInView({ threshold: 0.2 })
	const { ref: experienceRef, inView: experienceInView } = useInView({ threshold: 0.2 })

	const skills = [' HTML', ' CSS', ' JavaScript', ' React', ' Vue']

	useEffect(() => {
		const handleResize = () => {
			setWindowSize({ height: window.innerHeight, width: window.innerWidth })
		}
		window.addEventListener('resize', handleResize)
	}, [])

	return (
		<Wrapper className='stats' id='stats'>
			<div className='stats__description'>
				<Text>As</Text>
				<Text>
					<strong> frontend developer </strong>
				</Text>
				<Text>
					a with over two years of experience, I'm passionate about creating engaging and user-friendly websites. With
					expertise in
				</Text>
				{skills.map((skill, index) => (
					<Fragment key={skill}>
						<Text>
							<strong>{skill}</strong>
						</Text>
						<Text>{index !== skills.length - 1 ? ',' : '. '}</Text>
					</Fragment>
				))}
				<Text>
					I have delivered numerous successful web projects to clients. My attention to detail and ability to bring
					designs to life have earned me a reputation as a dedicated and reliable developer.
				</Text>
			</div>

			{isMobile && <Divider orientation='horizontal' sx={{ margin: '1rem 0 2rem', borderBottomWidth: 2 }} />}
			{!isMobile && <Divider orientation='vertical' flexItem sx={{ margin: '0 2rem 0 1rem', borderRightWidth: 2 }} />}

			<div ref={projectsRef} className='stats__entries'>
				<h6 className='stats__entry'>
					<div className='stats__number'>
						{!projectInView && '0'}
						{projectInView && (
							<Count
								start={0}
								end={20}
								duration={1.5}
								suffix='+'
								onStart={() => {
									setCountingFinished(false)
								}}
								onEnd={() => {
									setCountingFinished(true)
								}}
							/>
						)}
					</div>
					commercial projects
				</h6>
				<h6 ref={experienceRef} className='stats__entry'>
					<div className='stats__number'>
						{(!countingFinished || !experienceInView) && '0'}
						{countingFinished && experienceInView && <Count start={1} end={3} duration={0.4} suffix='+' />}
					</div>
					years of experience
				</h6>
			</div>
		</Wrapper>
	)
}

export default Stats
